module.exports = __webpack_public_path__ + "static/img/mainlogo.ec2315c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mainlogo.png
// module id = XuTf
// module chunks = 112